// Home-dashboard data. One tenant-scoped summary call backs the KPI strip, the
// 7-day run-outcome bar, and the "needs attention" list. AI usage comes from the
// existing Usage endpoint (settingsApi.getCurrentUsage); live activity is SignalR.

import type { DashboardSummary, DataSourceResultDto, WorkflowRunListItem } from '@shared/api-types';
import { apiFetch } from './apiClient';

export const getDashboardSummary = (signal?: AbortSignal) =>
  apiFetch<DashboardSummary>('/api/dashboard/summary', { signal });

/**
 * Newest `limit` runs across all the tenant's workflows — used to seed the
 * live-activity feed so it shows recent history while waiting for the next
 * streamed event. Reuses the run-history endpoint (Kendo DataSourceRequest);
 * we only need page 1, newest-first.
 */
export const getRecentRuns = (limit = 15, signal?: AbortSignal) =>
  apiFetch<DataSourceResultDto<WorkflowRunListItem>>(
    `/api/workflows/runs?page=1&pageSize=${limit}&sort=startedUtc-desc`,
    { signal },
  ).then((r) => r.data);
